import React from "react";
import MemberInformation from "./MemberInformation"
import MemberInformationAdmin from "./MemberInformationAdmin"


function MemberList({ openmodalWorkingTimeGraph, users, roles }) {
    return (
        <div>

            {roles === "Admin" && (
                <div className="ml-[370px]">
                    {users.map((user, index) => (
                        <div className="mb-[2vh] w-[97%]">
                            <MemberInformationAdmin openmodalWorkingTimeGraph={openmodalWorkingTimeGraph} user={user} index={index} />
                        </div>
                    ))}
                </div>
            )}

            {roles === "Member" && (
                <div className="ml-[370px]">
                    {users.map((user, index) => (
                        <div className="mb-[2vh] mx-[20px]">
                            <MemberInformation user={user} index={index} />
                        </div>
                    ))}
                </div>
            )}

        </div>
    )
};
export default MemberList;